import { Collection, CollectionItem, UserTreeCollectionModel } from '@aipb/gulliver/personal-content/model';
import { translate } from '@jsverse/transloco';

export function getCollectionLabel(collection: CollectionItem | Collection | UserTreeCollectionModel) {
  if (!collection) return '';

  if (collection.type === 'favorites') {
    return translate('personal_content.collection_types.favorites');
  }

  if (collection.type === 'trashbin') {
    return translate('personal_content.collection_types.trashbin');
  }

  return collection.label;
}

export function sortCollectionsAsc(items: Collection[] | CollectionItem[]) {
  return items.sort((c1, c2) => {
    if (c1.label && c2.label) {
      return c1.label.localeCompare(c2.label);
    } else {
      return c1.label ? 1 : -1;
    }
  });
}
